module.exports = __webpack_public_path__ + "img/apr.98dd4950.jpeg";